import HeadlinesButton from "./HeadlinesButton";

export default HeadlinesButton;